import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/customer/edit/customer.edit.mutation.gql"
import type {
  CustomerEditMutation,
  CustomerEditMutationVariables,
} from "@/v2-backoffice-client/customer/edit/__types__/customer.edit.mutation"

type Options = MutationHookOptions<
  CustomerEditMutation,
  CustomerEditMutationVariables
>

export function useCustomerEditMutation(options?: Options) {
  return useMutation<CustomerEditMutation, CustomerEditMutationVariables>(
    mutation,
    options,
  )
}
